<template>
    <div>
        <f-read-only-field
            v-if   = "readonly"
            class  = "w-100"
            :dense = "true"
            :label = "label"
            :value = "number"
            color  = "pt-0-5 pl-1 ro-background"
        />

        <v-text-field
            v-if           = "!readonly"
            type           = "number"
            :label         = "label"
            v-model        = "number"
            :readonly      = "readonly"
            autocomplete   = "off"
            autocorrect    = "off"
            autocapitalize = "off"
            spellcheck     = "false"
            :hide-details  = "hideDetails"
            :dense = "dense"
            :outlined = "outlined"
            @input         = "onInput"
        />
    </div>
</template>

<script>

import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";

export default {
    name: "FNumberFieldRw",
    components: {
        FReadOnlyField
    },

    props: {
        label: {
        },

        value: {

        },

        readonly: {
            required: false,
            default: function () {
                return false;
            }
        },

        hideDetails: {
            required: false,
            default: function () {
                return false;
            }
        },

        dense: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },

        outlined: {
            required: false,
            type    : Boolean,
            default: function () {
                return false;
            }
        },
    },

    data: () => ({
        number: null,
    }),

    mounted() {
        this.number = this.value;
    },

    watch: {
        value () {
            this.number = this.value;
        }
    },

    methods: {
        onInput () {
            console.log("number", this.number)
            this.$emit("input", this.number)
        },
    }
}
</script>

<style scoped>

</style>